export enum PumpingServicePropertiesEnum {
  REQUIRED_PUMP = 'CNX-PUMP-RPS',
  ALTERNATIVE_PUMP = 'CNX-PUMP-APS',
  PIPE_LENGTH = 'CNX-PUMP-PPL',
  DIAMETER = 'CNX-PUMP-DMT',
  PRIMER_BY_CEMEX = 'CNX-PUMP-PRI',
  COMMENTS = 'CNX-PUMP-COM',
  CLEANING_ON_SITE = 'CNX-PUMP-COS',
  FALL_PROTECTION = 'CNX-PUMP-FPR',
  POWER_LINE = 'CNX-PUMP-PLR',
}

export type PumpingServicePropertiesType =
  | PumpingServicePropertiesEnum.REQUIRED_PUMP
  | PumpingServicePropertiesEnum.ALTERNATIVE_PUMP
  | PumpingServicePropertiesEnum.PIPE_LENGTH
  | PumpingServicePropertiesEnum.COMMENTS
  | PumpingServicePropertiesEnum.PRIMER_BY_CEMEX
  | PumpingServicePropertiesEnum.DIAMETER
  | PumpingServicePropertiesEnum.CLEANING_ON_SITE
  | PumpingServicePropertiesEnum.POWER_LINE
  | PumpingServicePropertiesEnum.FALL_PROTECTION;
